import {useQuery} from "@tanstack/react-query";
import {AccountLevel, Token, UsersApi} from "@devour/client";
import getConfig from "@/utils/getConfig";

async function fetchUserLevel(fullToken: Token, userId: string): Promise<AccountLevel> {
    if (!userId || !fullToken) return;

    return await new UsersApi(getConfig(fullToken)).getUsersLevelId({
        id: userId,
    });
}

function useUserLevelQuery(fullToken: Token, userId: string, disabled?: boolean) {
    return {
        queryKey: [
            "user-level",
            fullToken?.id ?? "unauthenticated",
            userId ?? "",
        ],
        queryFn: () => fullToken && userId ? fetchUserLevel(fullToken, userId) : null,
        enabled: !!fullToken && !!userId && !disabled,
        staleTime: Infinity, // Never consider stale - updates via WebSocket/manual refetch
        gcTime: 24 * 60 * 60 * 1000, // Keep in cache for 24 hours
        refetchOnWindowFocus: false, // Don't refetch on tab switch - we have cache
    } as const;
}

export function useGetUserLevel(fullToken: Token, userId: string, disabled?: boolean) {
    return useQuery(useUserLevelQuery(fullToken, userId, disabled));
}